// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plyr__control.plyr__tab-focus{background-color:unset!important;-webkit-box-shadow:unset!important;box-shadow:unset!important;color:inherit!important}.plyr--full-ui input[type=range].plyr__tab-focus::-webkit-slider-runnable-track{-webkit-box-shadow:unset!important;box-shadow:unset!important}", ""]);
// Exports
module.exports = exports;
